import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

/*Services*/
import { AuthService } from '@services/http/auth.service';
import { CachedDataService } from '@services/data/cached-data.service';
import { BaseHttpService } from '@services/http/base-http.service';

/*Environment */
import { environment } from '@environments';

@Injectable()

export class ObjectsService extends BaseHttpService {
  public updateObjects: EventEmitter<null> = new EventEmitter<null>();

  constructor(protected httpClient: HttpClient,
    protected cachedDataService: CachedDataService,
    protected router: Router,
    protected authService: AuthService) {
    super(httpClient, cachedDataService, router, authService);
  }

  addObject(name: string, ObjectType: string, extra: string, userId: string): Observable<any> {
    const uri = environment.apiUri + 'object';
    const body = {
      name: name,
      ObjectType: ObjectType,
      extra: extra
    };
    if(userId){
      body['userId'] = userId;
    }
    return super.send('POST', uri, null, true, body);
  }

  changeObject(name: string, ObjectType: string, extra: string, id: string): Observable<any> {
    const uri = environment.apiUri + 'object';
    const body = {
      name: name,
      ObjectType: ObjectType,
      extra: extra,
      id: id
    };
    return super.send('PUT', uri, null, true, body);
  }

  deleteObject(id: string): Observable<any> {
    const uri = environment.apiUri + `object/${id}`;
    return super.send('DELETE', uri);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/http/objects.service.ts